<script lang="ts">
	import ApplicationForm from "@components/ApplicationForm.svelte";
	import Banner from "@components/Banner.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { getTranslate } from "@utils/translate.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./Application.translations.json" with { type: "json" };
	import type { ApplicationProps } from "./ApplicationProps.js";

	const _: ApplicationProps = $props();
	const { competition } = getGlobalTemplateProps();

	const translate = getTranslate(translations);
	const registrationStarted = new Date() > (competition ? new Date(competition.registrationStart) : new Date());
	const registrationEnded = new Date() > (competition ? new Date(competition.registrationEnd) : new Date());
</script>

<Layout>
	{#if competition}
		<Banner {competition} />
	{/if}

	{#if competition}
		{#if !registrationStarted}
			<p>{translate("registrationHasntStarted")}</p>
		{:else if !registrationEnded}
			<ApplicationForm {competition} />
		{:else}
			<p>{translate("registrationEnded")}</p>
		{/if}
	{/if}
</Layout>
